import { lazy, Suspense } from "react";
import type { RouteObject } from "react-router-dom";

const Home = lazy(() => import("../pages/home/page"));
const AboutPage = lazy(() => import("../pages/about/page"));
const ServicesPage = lazy(() => import("../pages/services/page"));
const ServiceDetailPage = lazy(() => import("../pages/services/detail/page"));
const ReferencesPage = lazy(() => import("../pages/references/page"));
const FAQPage = lazy(() => import("../pages/faq/page"));
const ContactPage = lazy(() => import("../pages/contact/page"));
const NotFound = lazy(() => import("../pages/NotFound"));

const Fallback = () => (
  <div className="min-h-screen flex items-center justify-center bg-cream">
    <div className="w-10 h-10 border-4 border-accent border-t-transparent rounded-full animate-spin" />
  </div>
);

const wrap = (el: React.ReactNode) => (
  <Suspense fallback={<Fallback />}>{el}</Suspense>
);

const routes: RouteObject[] = [
  { path: "/", element: wrap(<Home />) },
  { path: "/hakkimizda", element: wrap(<AboutPage />) },
  { path: "/hizmetler", element: wrap(<ServicesPage />) },
  { path: "/hizmetler/:serviceId", element: wrap(<ServiceDetailPage />) },
  { path: "/referanslar", element: wrap(<ReferencesPage />) },
  { path: "/sss", element: wrap(<FAQPage />) },
  { path: "/iletisim", element: wrap(<ContactPage />) },
  { path: "*", element: wrap(<NotFound />) },
];

export default routes;
